import React from 'react';
import SchedulerManager from '../components/SchedulerManager';

const SchedulerPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <SchedulerManager />
    </div>
  );
};

export default SchedulerPage;